/**
 * Stile condiviso dai badge tag SDB e dai badge tecnologia.
 * Le classi colore vengono aggiunte dal chiamante.
 */
export const TAG_CHIP_BASE = 'inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold leading-tight whitespace-nowrap'

/** Tag SDB con un colore semantico stabile; gli altri usano un hash. */
const KNOWN_COLORS: Record<string, string> = {
  SDWAN: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  CW: 'border-violet-200 bg-violet-50 text-violet-700',
  'NRD2025-INPROGRESS': 'border-amber-200 bg-amber-50 text-amber-700'
}

const PALETTE = [
  'border-sky-200 bg-sky-50 text-sky-700',
  'border-indigo-200 bg-indigo-50 text-indigo-700',
  'border-rose-200 bg-rose-50 text-rose-700',
  'border-teal-200 bg-teal-50 text-teal-700',
  'border-orange-200 bg-orange-50 text-orange-700',
  'border-slate-300 bg-slate-100 text-slate-700',
  'border-cyan-200 bg-cyan-50 text-cyan-700',
  'border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700'
]

export interface TagChipLike {
  code?: string | null
  label?: string | null
}

/** Classi complete per un badge tag SDB. */
export function sdbTagChipClasses (tag: TagChipLike): string {
  const code = String(tag?.code ?? tag?.label ?? '').trim().toUpperCase()
  const color = KNOWN_COLORS[code] ?? PALETTE[hash(code) % PALETTE.length]
  return `${TAG_CHIP_BASE} ${color}`
}

function hash (value: string): number {
  let hash = 7
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0
  }
  return hash
}
